var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.Leave}},[_vm._v("Leave")]),_c('div',{staticClass:"list",class:`list${_vm.index}`})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }